module.exports = __webpack_public_path__ + "static/media/maps.55ca81fc.txt";